import { useEffect } from 'react';
import useUpdate from 'react-use/lib/useUpdate';
export default function useUpdaters(memoized) {
    const update = useUpdate();
    useEffect(() => {
        const { updaters } = memoized;
        updaters.add(update);
        return () => {
            updaters.delete(update);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memoized]);
}
//# sourceMappingURL=useUpdaters.js.map